import type { UnifiedFieldsApiTyped } from './types';

import './setup';
import { unifiedFieldsApiRoot } from './root';

export const unifiedFields = unifiedFieldsApiRoot as UnifiedFieldsApiTyped;
